export default __webpack_public_path__ + "static/award-06-2feee710a3c6189206680d55f4d3aaa3.png";